import generateIcon from "../generateIcon";

const Edit = generateIcon("fas fa-edit");

export default Edit;